import React from 'react';
import {
  PageHeader, Panel, PanelGrid, ProfileHeader, PasswordForm, OptionChips, Button, Tag,
} from '@NP-Webber/crm-kit/dist/next/index.js';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../services/api';
import useNextDesign from '../../next/useNextDesign';
import { openNextDesignTour } from '../../next/NextDesignTour';

/**
 * אזור אישי — new design. Same endpoint as ProfilePage (/auth/change-password, min 6 characters),
 * plus the display options of the new design (per user), like Turbo's personal area.
 */
export default function ProfilePageNext() {
  const { user } = useAuth();
  const nextDesign = useNextDesign();

  const changePassword = async (currentPassword, newPassword) => {
    if (String(newPassword).length < 6) return { success: false, message: 'הסיסמה החדשה חייבת להכיל לפחות 6 תווים' };
    try {
      const { data } = await api.post('/auth/change-password', { currentPassword, newPassword });
      return { success: true, message: data?.message || 'הסיסמה עודכנה בהצלחה' };
    } catch (err) {
      return { success: false, message: err.response?.data?.error || 'שגיאה בעדכון הסיסמה' };
    }
  };

  const roles = user?.roles || [];
  return (
    <>
      <PageHeader title="אזור אישי" sub="פרטים, סיסמה והעדפות תצוגה" />
      <Panel>
        <ProfileHeader
          name={user?.username || ''}
          sub={roles.includes('admin') ? 'מנהל מערכת' : roles.join(' · ')}
        />
      </Panel>
      <PanelGrid cols={2}>
        <Panel title="פרטי משתמש" icon="user">
          <div className="pa-rows">
            <div className="pa-row"><span>שם משתמש</span><b dir="ltr">{user?.username}</b></div>
            <div className="pa-row">
              <span>תפקידים</span>
              <span className="pa-tags">{roles.length ? roles.map((r) => <Tag key={r} tone="primary">{r}</Tag>) : <span className="ck-muted">—</span>}</span>
            </div>
            {Array.isArray(user?.cities) && user.cities.length ? (
              <div className="pa-row">
                <span>ערים</span>
                <span className="pa-tags">{user.cities.map((c) => <Tag key={c}>{c}</Tag>)}</span>
              </div>
            ) : null}
          </div>
        </Panel>
        <Panel title="שינוי סיסמה" icon="key">
          <PasswordForm onSubmit={changePassword} requirements={['לפחות 6 תווים']} />
        </Panel>
      </PanelGrid>
      <PanelGrid cols={2}>
        <Panel title="תצוגה" sub="העיצוב החדש — לכל משתמש בנפרד" icon="sun">
          <div className="pa-rows">
            <div className="pa-row">
              <span>סגנון</span>
              <OptionChips ariaLabel="סגנון" value={nextDesign.style} onChange={nextDesign.setStyle} options={[{ value: 'modern', label: 'מודרני' }, { value: 'classic', label: 'קלאסי' }, { value: 'retro', label: 'רטרו' }]} />
            </div>
            <div className="pa-row">
              <span>מצב</span>
              <OptionChips ariaLabel="מצב" value={nextDesign.mode} onChange={nextDesign.setMode} options={[{ value: 'light', label: 'בהיר' }, { value: 'dark', label: 'כהה' }, { value: 'system', label: 'לפי המכשיר' }]} />
            </div>
            {nextDesign.style !== 'modern' && nextDesign.mode === 'dark' ? <span className="ck-muted">מצב כהה זמין כרגע בסגנון המודרני בלבד.</span> : null}
            <hr />
            <div className="pa-row"><span>סיור בעיצוב החדש</span><Button size="sm" variant="ghost" icon="sparkle" onClick={openNextDesignTour}>פתיחת הסיור</Button></div>
            <div className="pa-row"><span>חזרה לעיצוב הקודם</span><Button size="sm" variant="ghost" icon="swap" onClick={() => nextDesign.setEnabled(false)}>מעבר לעיצוב הישן</Button></div>
          </div>
        </Panel>
        <Panel title="קיצורי מקלדת" icon="grid">
          <div className="pa-rows pa-keys">
            <div className="pa-row"><span>חיפוש מהיר — חבר, כולל, מבחן, מסך או פעולה</span><kbd className="ck-kbd">Ctrl K</kbd></div>
            <div className="pa-row"><span>יצירה מהירה (לפי הסדר בתפריט „חדש”)</span><kbd className="ck-kbd">Alt 1…9</kbd></div>
            <div className="pa-row"><span>הגדרות קשורות למסך הזה</span><kbd className="ck-kbd">Ctrl ,</kbd></div>
          </div>
        </Panel>
      </PanelGrid>
    </>
  );
}
